import React, {ChangeEvent, useEffect, useState} from 'react';
import s from './MyInput.module.css'
import classnames from "classnames";

type PropsType = {
    password?: boolean
    isError?: any
    id?: string
    name?: string
    value?:string | number
    placeholder?: string
    onChange?: { (e: ChangeEvent<any>): void;}
    touched?:  any,
    width?: string,
    ref?: any,
    disabled?: boolean
}

const MyInput = (props: PropsType) => {

    const {
        password,
        isError,
        touched,
        width,
        ...restProps
    } = props;

    const [inputType, setInputType] = useState("text")

    useEffect(() => {
        if (password) {
            setInputType("password")
        }
    }, [password])


    const changeInputType = (e: any) => {

        e.preventDefault()

        if (inputType === "password") {
            setInputType("text")
        }

        if (inputType === "text") {
            setInputType("password")
        }

    }


    return (
        <div className={s.inputWrapper} style={{width: width}}>
            <input type={inputType}
                   autoComplete="off"
                   className={classnames(s.my_input, {[s.error_input]: !!isError && touched})}
                   {...restProps}
            />
            <div className={password ? s.view : s.hidden}>
                <a href="#/" className={inputType === "text" ? s.passwordView : s.passwordControl}
                   onClick={(e) => changeInputType(e)}>
                </a>
            </div>

        </div>

    );
}

export default MyInput;
